import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Material, MaterialValue } from '../models';

export const materialActions = createActionGroup({
    source: 'Material',
    events: {
        'Get Material': props<{ id: string }>(),
        'Get Material Success': props<{ payload: Material }>(),
        'Get Material Error': props<{ code: number }>(),

        'Create Material': props<{ value: MaterialValue }>(),
        'Create Material Success': props<{ payload: Material }>(),
        'Create Material Error': props<{ code: number }>(),

        'Update Material': props<{ id: string; value: MaterialValue }>(),
        'Update Material Success': props<{ payload: Material }>(),
        'Update Material Error': props<{ code: number }>(),

        'Delete Material': props<{ id: string }>(),
        'Delete Material Success': props<{ id: string }>(),
        'Delete Material Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
